import * as types from "./actionTypes";
import axios from "axios";

export const getSpecials = specialsId => dispatch => {
  axios
    .get(process.env.REACT_APP_API_URL + "/specials/" + specialsId)
    .then(({ data }) => {
      return dispatch({
        type: types.SPECIALS_GET,
        data
      });
    })
    .catch(err => console.log(err));
};

export const getSpecialsTypes = specialsId => dispatch => {
  axios
    .get(
      process.env.REACT_APP_API_URL +
        "/specials/" +
        specialsId +
        "/event_filter/types"
    )
    .then(({ data }) => {
      return dispatch({
        type: types.SPECIALS_FILTER_TYPES_GET,
        data
      });
    });
};

export const getSpecialsDates = specialsId => dispatch => {
  axios
    .get(
      process.env.REACT_APP_API_URL +
        "/specials/" +
        specialsId +
        "/event_filter/dates"
    )
    .then(({ data }) => {
      return dispatch({
        type: types.SPECIALS_FILTER_DATES_GET,
        data
      });
    });
};

export const getSpecialsOptions = specialsId => dispatch => {
  axios
    .get(
      process.env.REACT_APP_API_URL +
        "/specials/" +
        specialsId +
        "/event_filter/options"
    )
    .then(({ data }) => {
      return dispatch({
        type: types.SPECIALS_FILTER_OPTIONS_GET,
        data
      });
    });
};

export const changeSpecialsView = () => dispatch => {
  return dispatch({
    type: types.SPECIALS_CHANGE_VIEW
  });
};

export const resetSpecials = () => dispatch => {
  return dispatch({
    type: types.SPECIALS_RESET
  });
};



// WEBPACK FOOTER //
// ./src/modules/specials/actions.js